import React from "react";
import HeroSection from "./LandingPage/HeroSection/HeroSection";
import FeaturesSection from "./LandingPage/FeaturesSection/FeaturesSection";
import StepsSection from "./LandingPage/StepsSection/StepsSection";
import CtaSection from "./LandingPage/CtaSection/CtaSection";
import { Users, Award, TrendingUp } from "lucide-react";

const LandingPage: React.FC = () => {
    // Define stats out of JSX
    const stats = [
        {
            number: "100+",
            label: "Companies",
            Icon: <Users className="w-7 h-7 text-white" />,
            color: "bg-gradient-to-r from-purple-500 to-indigo-500",
        },
        {
            number: "50K+",
            label: "Recognitions",
            Icon: <Award className="w-7 h-7 text-white" />,
            color: "bg-gradient-to-r from-green-500 to-emerald-500",
        },
        {
            number: "98%",
            label: "Satisfaction",
            Icon: <TrendingUp className="w-7 h-7 text-white" />,
            color: "bg-gradient-to-r from-orange-500 to-red-500",
        },
    ];
    

    return (
        <div>
            <HeroSection
                title="Power Up Your Team's Success Story"
                description="Transform your workplace culture with meaningful recognition and celebrate every achievements, boost morale, and create a thriving environment where everyone feels valued."
                
                stats={stats}  
            />

            <FeaturesSection />
            <StepsSection />
            <CtaSection/>
        </div>
    );
};

export default LandingPage;
